<div 
  class="font-weight-bold font-size-normal text-tertiary p-0 opacity-dark-9 cursor-pointer" 
  (click)="openColorLegendPopup(legendColorCodeTemplate)">
  <img 
    [alt]="'IMAGE_DESCRIPTION.COLOR_LEGEND' | translate" 
    src="assets/images/colorcode/icon-colorcodelegend-{{ theme$ | async }}.svg"
    [matTooltip]="'HEADER.COLOR_CODE_DESCRIPTION' | translate" 
    matTooltipPosition="below" 
    />
</div>

<ng-template #legendColorCodeTemplate>
  <div class="modal-dialog centered modal-lg">
    <div class="modal-content h-100">
      <div class="modal-header">
        <lib-content-box-buttons [buttons]="buttons" [active]="active" (activeChanged)="changeActiveTab($event)"> </lib-content-box-buttons>
        <button data-testid="color-code-legend-close-button" type="button" class="close pull-right" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12" style="text-align: center">
            @if (active === 0) {
              <app-park-legend></app-park-legend>
            }
            @if (active === 1) {
              <app-turbine-legend></app-turbine-legend>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
